import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { useQuery } from 'modules/core/hooks/useQuery'
import { UniversalUpdaterEmployeesDocument } from 'generated/resources/graphql'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const UniversalUpdaterEmployeesPage = () => {
  const { company, access } = useCurrentSession()
  const { legal_entity_id: legalEntityId } = useParams<{ legal_entity_id?: string }>()
  const location = useLocation()
  const selectedFields: string[] | undefined = location.state?.selectedFields

  // Multi-LE mode: legalEntityId is 'all' sentinel. selectedFields may be undefined on refresh
  // (location.state is ephemeral), in which case NuvoImporter shows all fields (graceful fallback).
  const isMultiLeMode = legalEntityId === 'all'

  const { data, loading, error } = useQuery(UniversalUpdaterEmployeesDocument, {
    variables: {
      companyId: company.id,
      legalEntityIds: isMultiLeMode ? [] : [String(legalEntityId)],
    },
    fetchPolicy: 'network-only',
    skip: !legalEntityId,
  })

  const hasDevUniversalUpdaterEmployeesFeature =
    data?.features.featuresConnection.edges.find(
      (feature) => feature.node.name === 'dev_universal_updater_employees'
    )?.node.enabled ?? false
  const canEditEmployeesInBulk = data?.employees._policies.editEmployeesInBulkButton.can ?? false
  // In multi-LE mode, authorization was checked via the same query (features + policies)
  const isAuthorized = canEditEmployeesInBulk && hasDevUniversalUpdaterEmployeesFeature

  const locale = access.locale
  const legalEntityCountry = data?.companies.legalEntitiesConnection.nodes[0]?.country
  const metadata = {
    legal_entity_ids: legalEntityId && !isMultiLeMode ? [BigInt(legalEntityId)] : [],
    legal_entity_countries: !isMultiLeMode && legalEntityCountry ? [legalEntityCountry] : [],
  }

  return (
    <ResponsivePage.Body
      authorized={isAuthorized}
      loading={loading}
      error={error}
      showHeader={false}
    >
      <NuvoImporter
        importType="employee_edition"
        locale={locale}
        companyId={company.id}
        metadata={metadata}
        selectedFields={selectedFields}
        useFileUploadInEdition
      />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default UniversalUpdaterEmployeesPage
